import { render, staticRenderFns } from "./popup-leader-close.vue?vue&type=template&id=5fea7a68&scoped=true"
import script from "./popup-leader-close.vue?vue&type=script&lang=js"
export * from "./popup-leader-close.vue?vue&type=script&lang=js"
import style0 from "./popup-leader-close.vue?vue&type=style&index=0&id=5fea7a68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea7a68",
  null
  
)

export default component.exports